import { z } from 'zod';

export const clientExportSettingSchema = z.object({
  id: z.number().int().positive().optional(),
  claim_section_id: z.number().int().positive('Claim section is required'),
  active: z.boolean(),
  settings: z.object({
    url: z.string().min(1, 'URL is required').url('URL must be valid'),
  }),
});

export const clientSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(60),
  export_settings: z.array(clientExportSettingSchema).optional(),
});

export type ClientInput = z.infer<typeof clientSchema>;
export type ClientExportSettingInput = z.infer<typeof clientExportSettingSchema>;
